import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueI18n from "vue-i18n";
import en from "./lang/locals/en.json";
import arb from "./lang/locals/arabic.json";
import VueCookies from "vue-cookies";
import Toasted from "vue-toasted";

Vue.config.productionTip = false;
Vue.use(Toasted, {
  position: "bottom-right",
  duration: 5000
});
Vue.use(VueI18n);
Vue.use(VueCookies);
const messages = {
  en: en,
  arb: arb
};
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "en", // set locale
  messages // set locale messages
});

export const eventBus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
